import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

const SpeedLeft = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
	return (
		<SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
			<g transform="matrix(-1,0,0,1,24.477,0.0713532)">
				<path
					d="M20.38,8.57L19.15,10.42C20.354,12.821 20.271,15.673 18.93,18L5.07,18C4.37,16.785 4.001,15.407 4.001,14.005C4.001,9.616 7.612,6.005 12.001,6.005C13.243,6.005 14.469,6.294 15.58,6.85L17.43,5.62C15.819,4.587 13.945,4.038 12.032,4.038C6.546,4.038 2.032,8.552 2.032,14.038C2.032,15.778 2.486,17.489 3.35,19C3.705,19.614 4.361,19.996 5.07,20L18.92,20C19.636,20.003 20.302,19.62 20.66,19C22.536,15.751 22.431,11.708 20.39,8.56L20.38,8.57ZM10.59,15.41C10.965,15.785 11.474,15.997 12.005,15.997C12.536,15.997 13.045,15.785 13.42,15.41L19.08,6.92L10.59,12.58C10.215,12.955 10.003,13.464 10.003,13.995C10.003,14.526 10.215,15.035 10.59,15.41"
					fill="currentColor"
					fillRule="nonzero"
				/>
			</g>
		</SvgIcon>
	);
});

SpeedLeft.displayName = "SpeedLeft";

export default SpeedLeft;
